import styles from 'pages/WelcomePage/components/Publications/Publications.module.scss';
import useNews from 'app/hooks/useNews';
import { galateaDifferenceUrls } from 'app/routing';
import { Body, Heading } from 'components/Typography';

import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const News: React.FC = () => {
  const { t } = useTranslation();
  const { fetchNews, news } = useNews();

  useEffect(() => {
    const abortController = new AbortController();
    fetchNews('', '', abortController);

    return () => {
      abortController.abort();
    };
  }, [ fetchNews ]);

  return (
    <div className={styles.publications} data-cy="news">

      <div>

        <div className={styles.publications__header}>
          <Heading>{t('welcomePage.galateaInNews')}</Heading>
        </div>

        <div className={styles.publications__list}>

          {news.items.slice(0, 3).map(item => (
            <Link to={galateaDifferenceUrls.newsDetailUrl(item.meta.slug)} className={styles.publications__listItem} key={item.id}>
              <Body variant="M" className={styles.publications__link}>{item.title}</Body>
            </Link>
          ))}

        </div>

      </div>

      <div>

        <div className={styles.publications__separator} />

        <Link to={galateaDifferenceUrls.news} className={styles.publications__showAll}>
          <Body variant="L">{t('welcomePage.showAll')}</Body>
        </Link>

      </div>

    </div>
  );
};

export default News;
